module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAQAAADMUVVtAAAAGElEQVQIW2NggIAGKA1mQiASE4WDpBAIAOjBB4GXx+V+AAAAAElFTkSuQmCC"